import { AgGridReact } from 'ag-grid-react';
import type { ColDef, RowClickedEvent } from 'ag-grid-community';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';

// Register AG Grid modules
ModuleRegistry.registerModules([AllCommunityModule]);

interface DataGridProps<T> {
  data: T[];
  columns: ColDef<T>[];
  loading?: boolean;
  height?: number | string;
  onRowClick?: (data: T) => void;
  pagination?: boolean;
  pageSize?: number;
}

export function DataGrid<T>({
  data,
  columns,
  loading = false,
  height = 500,
  onRowClick,
  pagination = true,
  pageSize = 50,
}: DataGridProps<T>) {
  const handleRowClicked = (event: RowClickedEvent<T>) => {
    if (onRowClick && event.data) {
      onRowClick(event.data);
    }
  };

  return (
    <div className="ag-theme-alpine" style={{ height, width: '100%' }}>
      <AgGridReact<T>
        rowData={data}
        columnDefs={columns}
        loading={loading}
        pagination={pagination}
        paginationPageSize={pageSize}
        paginationPageSizeSelector={[20, 50, 100, 200]}
        onRowClicked={handleRowClicked}
        defaultColDef={{
          sortable: true,
          filter: true,
          resizable: true,
          minWidth: 80,
        }}
        animateRows={true}
        rowSelection="single"
        suppressCellFocus={true}
      />
    </div>
  );
}
